/**
 * The IANA timezone the browser reports, e.g. `Australia/Perth`.
 *
 * Pre-screening sends this so the API can keep patients in regions without
 * direct-to-doctor cover on the nurse flow. It is a hint, not a fact: it
 * reflects the device's clock setting rather than where the patient lives, so
 * the API treats a missing or unrecognised value as "route as normal".
 */
export const getBrowserTimezone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};
